module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    on: {
      "open": function($event) {
        _vm.open()
      },
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-large main-toolbar"
  }, [_c('div', {
    staticClass: "md-toolbar-container ql-toolbar-logo"
  }, [_c('h1', [_c('img', {
    staticClass: "logo-text",
    attrs: {
      "src": require('../../../assets/img/cuelisttextWHITE.png'),
      "alt": "cuelisttext"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require('../../../assets/img/cuelist.png'),
      "alt": "cuelist"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "md-toolbar-container ql-toolbar-avatar"
  }, [_c('md-avatar', {
    staticClass: "md-small"
  }, [(_vm.user.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.user.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": require('../../../assets/img/silhouette.jpg'),
      "alt": "People"
    }
  })]), _vm._v(" "), (_vm.user.username) ? _c('div', {
    staticClass: "md-subtitle avatar-name-role"
  }, [_vm._v(_vm._s(_vm.user.username))]) : _c('div', {
    staticClass: "md-subtitle avatar-name-role"
  }, [_vm._v("Cuelist User")])], 1)]), _vm._v(" "), _c('md-list', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      },
      "tag": "md-list-item"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.projectsClick()
      }
    }
  }, [_vm._v("All Projects")])]), _vm._v(" "), (_vm.project) ? _c('md-list-item', [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.project.title))])])]) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('md-list-item', [_c('md-list', [_c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.collaboratorsClick()
      }
    }
  }, [_c('span', [_vm._v("Collaborators")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.layersClick()
      }
    }
  }, [_c('span', [_vm._v("Layers")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.historyClick()
      }
    }
  }, [_c('span', [_vm._v("History")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.projectSettingsClick()
      }
    }
  }, [_c('span', [_vm._v("Project Settings")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.printClick()
      }
    }
  }, [_c('span', [_vm._v("Print")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "md-list-item",
      "to": {
        name: 'account'
      }
    }
  }, [_c('span', [_vm._v("Account Settings")])]), _vm._v(" "), (_vm.user.admin) ? _c('router-link', {
    attrs: {
      "tag": "md-list-item",
      "to": {
        name: 'admin'
      }
    }
  }, [_c('span', [_vm._v("Admin Dashboard")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "md-list-item"
  }, [_c('div', {
    staticClass: "md-button md-list-item-container"
  }, [_c('span', [_vm._v("Help")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-button-ghost",
    on: {
      "click": _vm.helpClick
    }
  })], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.logoutClick()
      }
    }
  }, [_c('span', [_vm._v("Log Out")])])], 1)], 1), _vm._v(" "), (_vm.project) ? _c('layers-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('collaborators-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('print-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('project-settings-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('history-nav', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fe08595","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/core/nav/main.vue
// module id = 637
// module chunks = 2